import React, { useEffect, useState } from 'react';
export function StickyAlertBar() {
  const [seconds, setSeconds] = useState(599); // 9:59
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const display = `${minutes}:${secs.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-forest-900 text-white py-3 px-4 text-center shadow-md" data-id="element-202">
      <p className="text-sm md:text-base font-bold tracking-wide flex items-center justify-center gap-2" data-id="element-203">
        ⏳ OFERTA EXPIRA EN:
        <span className="inline-block bg-white text-forest-900 font-bold px-3 py-1 rounded-md tabular-nums min-w-[4.5ch]" data-id="element-204">
          {display}
        </span>
      </p>
    </div>;
}